<template>
  <div id="app" v-visibility-change="onVisibilityChange">
    <q-layout view="hHh lpR fFf" style="height: 100%">
      <q-header>
        <q-toolbar>
          <router-link to="/" aria-label="homepage" class="toolbar-home"
            ><img
              alt="Open Links Owl Logo"
              src="@/assets/owl-horizontal-white.png"
          /></router-link>
          <q-space></q-space>
          <div v-if="isLoading" class="spinner q-pr-md">
            <q-spinner-ball color="white" size="1.5em" :thickness="2" />
          </div>
          <q-btn
            v-if="showUpgradeButton"
            flat
            dense
            label="Register"
            text-color="white"
            @click="showFeatures = true"
          />
          <q-dialog v-model="showFeatures">
            <q-card>
              <q-card-section>
                <FeaturesTable></FeaturesTable>
              </q-card-section>

              <q-separator />

              <q-card-actions align="around">
                <q-btn
                  flat
                  color="primary"
                  href="https://youtu.be/3uoIT0I_Hb8"
                  target="_blank"
                  >Intro Video</q-btn
                >
                <q-btn
                  color="white"
                  text-color="red-14"
                  push
                  to="/register"
                  v-close-popup
                  ><span class="text-bold">Register Now</span></q-btn
                >
              </q-card-actions>
            </q-card>
          </q-dialog>
          <q-btn
            flat
            dense
            round
            @click="leftDrawerOpen = !leftDrawerOpen"
            aria-label="Menu"
            icon="menu"
          />
        </q-toolbar>
      </q-header>

      <q-drawer
        v-model="leftDrawerOpen"
        bordered
        overlay
        behavior="mobile"
        content-class="bg-grey-2"
        side="right"
        no-swipe-open
        no-swipe-close
      >
        <q-list>
          <q-item v-if="isPremium && isAdmin" to="/admin/users">
            <q-item-section avatar>
              <q-icon name="admin_panel_settings" />
            </q-item-section>
            <q-item-section>
              <q-item-label>User Administration</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="isPremium && isAdmin" to="/admin/reviews">
            <q-item-section avatar>
              <q-icon name="admin_panel_settings" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Reviews Summary</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="isPremium" to="/user-profile">
            <q-item-section avatar>
              <q-icon name="account_circle" />
            </q-item-section>
            <q-item-section>
              <q-item-label>User Profile</q-item-label>
            </q-item-section>
          </q-item>
          <q-item to="/">
            <q-item-section avatar>
              <q-icon name="sports_golf" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Course Screener</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="!currentUser" clickable to="/register">
            <q-item-section avatar>
              <q-icon name="how_to_reg" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Register</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            tag="a"
            target="_blank"
            href="https://openlinksgolf.com/members-journal"
          >
            <q-item-section avatar>
              <q-icon name="article" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Member's Journal</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            tag="a"
            target="_blank"
            href="https://www.youtube.com/channel/UCviCm_7rknIWWRdTjvTbNnw"
          >
            <q-item-section avatar>
              <q-icon name="school" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Training</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            clickable
            tag="a"
            target="_blank"
            rel="noopener"
            href="https://forms.gle/YrSqGwJuPrgodbV68"
          >
            <q-item-section avatar>
              <q-icon name="feedback" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Feedback</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable to="/terms-of-use">
            <q-item-section avatar>
              <q-icon name="description" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Terms of Service</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="!currentUser" clickable to="/login">
            <q-item-section avatar>
              <q-icon name="login" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Login</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-if="currentUser"
            clickable
            @click="[signOut(), (leftDrawerOpen = !leftDrawerOpen)]"
            ><q-item-section avatar>
              <q-icon name="logout" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Logout</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-drawer>
      <q-page-container>
        <router-view />
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
import * as fb from "@/firebaseConfig";
import { mapGetters, mapState } from "vuex";

import "quasar/dist/quasar.css";
import "@quasar/extras/material-icons/material-icons.css";
import FeaturesTable from "@/components/FeaturesTable";

export default {
  name: "App",
  components: { FeaturesTable },
  data() {
    return {
      leftDrawerOpen: false,
      showFeatures: false,
    };
  },
  beforeCreate() {
    this.$store.dispatch("fetchApplicationData");
    // this.$store.dispatch("getGeoLocation");
  },
  mounted() {
    // if it's the first time loading and the user has saved default columns, use those...
    this.initialSavedColumnsWatch = this.$watch("savedColumns", newVal => {
      console.debug("initialSavedColumnsWatch setFilterColumns", newVal);
      this.$store.commit("setFilterColumns", newVal);

      // remove ourselves, there's no need to watch anymore...
      this.initialSavedColumnsWatch();
    });
  },
  computed: {
    ...mapState(["isLoading", "currentUser"]),
    ...mapGetters(["isAdmin", "isPremium", "savedColumns", "uid"]),
    showUpgradeButton() {
      if (this.uid !== null) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    signOut() {
      this.$store.commit("setIsLoading", true);

      this.$store
        .dispatch("appendAuthEvent", "logout")
        .then(() => {
          return this.$store.dispatch("reset");
        })
        .then(() => {
          return fb.auth.signOut();
        })
        .then(() => {
          console.log("Sign-out successful");

          this.$q.notify({
            position: "bottom",
            type: "info",
            timeout: 5000,
            message: "You have been logged out successfully.",
          });

          this.$store.commit("setIsLoading", false);

          if (this.$route.path !== "/") {
            this.$router.push("/");
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.$store.commit("setIsLoading", false);
        });
    },
    onVisibilityChange(e, hidden) {
      if (hidden) {
        return;
      }

      this.$store.dispatch("fetchIdToken");
    },
  },
};
</script>
<style lang="scss">
body {
  font-family: Arial, Helvetica, sans-serif;
}

.app-toolbar a {
  text-decoration: none;
}

#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

#app .q-toolbar__title {
  font-family: Georgia, "Times New Roman", Times, serif;

  a {
    color: white;
    text-decoration: none;
  }
}

#app .gm-style {
  font-family: Arial, Helvetica, sans-serif;
}

.toolbar-home {
  display: inline-flex;
}
</style>
